import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../utils/cn';

export function ILMSSkeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-surface-muted', className)} />;
}

/** Skeleton rows for a table/list that is loading. */
export function ILMSTableSkeleton({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div className="w-full">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 py-3 border-b border-ink-300/10 last:border-0">
          {Array.from({ length: columns }).map((__, c) => (
            <ILMSSkeleton key={c} className={cn('h-4', c === 0 ? 'w-1/4' : 'flex-1')} />
          ))}
        </div>
      ))}
    </div>
  );
}

/** Skeleton grid for KPI cards while dashboard data loads. */
export function ILMSCardSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-lg border border-ink-300/20 p-4 space-y-3">
          <ILMSSkeleton className="h-3 w-2/3" />
          <ILMSSkeleton className="h-7 w-1/2" />
          <ILMSSkeleton className="h-3 w-1/3" />
        </div>
      ))}
    </div>
  );
}

export function ILMSSpinner({ label = 'Loading…', className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex items-center justify-center gap-2 py-10 text-ink-500', className)}>
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
      <span className="text-secondary">{label}</span>
    </div>
  );
}
